import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/assets/:id',
		name: 'assets',
		component: () =>
			import(/* webpackChunkName: "assets" */ '../views/Assets.vue')
	},
	{
		path: '/assets/book/:id/:slot',
		name: 'bookasset',
		component: () =>
			import(/* webpackChunkName: "bookasset" */ '../views/BookAsset.vue')
	},
	{
		path: '/reserve',
		name: 'reserve',
		component: () =>
			import(/* webpackChunkName: "reserve" */ '../views/Reserve.vue')
	},
	{
		path: '/reserve/room/:id',
		name: 'reserveRoom',
		component: () =>
			import(/* webpackChunkName: "reserve" */ '../views/ReserveRoom.vue')
	},
	{
		path: '/attend',
		name: 'attend',
		component: () =>
			import(/* webpackChunkName: "attend" */ '../views/Attend.vue')
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
